module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/cineicc-90fc283158a1337ae88db5dbac5d69a9.svg";